import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Contributors from './contributors';
import Current from './current';
import Previous from './previous';

const headerHeight = 32;
const rowHeight = 80;
const Container = styled.div`
  display: flex;

  & .header {
    display: flex;
    flex-direction: column;
    height: ${headerHeight}px;
  }

  & .row {
    height: ${rowHeight}px;
    border-bottom: 1px solid rgba(16, 58, 107, 0.07);
  }
`;

export default function Ranking({ contributorCount }) {
  return (
    <Container>
      <Contributors />
      <Current contributorCount={contributorCount} />
      <Previous />
    </Container>
  );
}

Ranking.propTypes = { contributorCount: PropTypes.number.isRequired };
